import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
// import { getMyWalletTickets } from 'modules/events/events-actions'
import { getParentApproval, resendParentRequest, selfScanWallet, getMembershipSignup } from 'modules/memberships/memberships-actions'
import { Avatar, notification } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { CustomButton, MemberLyfeLayout } from '../../components'
// import QrReader from 'react-qr-reader2'
import success from 'images/passSuccess.svg'
import moment from 'moment'

import fail from 'images/passInactive.svg'
import QRScanner from 'react-qr-scanner'
import { ReactComponent as FlashIcon } from 'images/flashIcon.svg'
import c from 'classnames'
import './index.styl'
import VisitHistory from './VisitHistory'
import ModalChangeEmail from '../../components/ModalChangeEmail'
import ModalAdditionalInformation from '../../components/ModalAdditionalInformation'

const DetailMembership = () => {
  const history = useHistory()
  const { user } = useSelector(state => state?.session)
  const [visible, setVisible] = useState(false)
  const [parentApproveStatus, setParentApproveStatus] = useState('')
  const [parentEmail, setParentEmail] = useState('')
  const [signupFields, setSignupFields] = useState([])
  const [showScanner, setShowScanner] = useState(false)
  const [flashEnabled, setFlashEnabled] = useState(false)
  const [scanningStatus, setScanningStatus] = useState(null)
  const [visibleAdditionalInformation, setVisibleAdditionalInformation] = useState(false)
  // const [scanCompleted, setScanCompleted] = useState(false)
  const [scannedOn, setScannedOn] = useState([])
  const scanCompleted = useRef(false)
  const [cameraAccess, setCameraAccess] = useState(false)
  const location = useLocation()
  const dispatch = useDispatch()
  const { ticketData } = location.state
  const isTablet = window.innerWidth < 1024
  const icons = { success, fail }
  const handleVisitHomePage = () => {
    history.push(`/memberPage/${ticketData.eventID}/${ticketData.userID}`)
    window.scrollTo(0, 0)
  }
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    if (ticketData?.parentApproval && ticketData?.isMinor) {
      dispatch(getParentApproval(ticketData?.eventID)).then(data => {
        setParentApproveStatus(data?.data?.parentApproval)
        setParentEmail(data?.data?.parentEmail)
      })
    }
  }, [ticketData])
  useEffect(() => {
    if (!ticketData?.managerApproved) {
      dispatch(getMembershipSignup(ticketData?.memberID)).then(data => {
        setSignupFields(data.data?.signupInfo)
      })
    }
  }, [])

  useEffect(() => {
    // check camera access
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        setCameraAccess(true)
        stream.getTracks().forEach(track => track.stop())
      })
      .catch(() => {
        setCameraAccess(false)
      })
  }, [])

  const resendEmailHandler = () => {
    dispatch(resendParentRequest({ eventID: ticketData?.eventID }))
  }

  const changeEmailHandler = values => {
    const obj = {
      eventID: ticketData?.eventID,
      email: values.email,
    }
    dispatch(resendParentRequest(obj)).then(() => {
      setVisible(false)
    })
  }

  const handleScan = data => {
    if (!data || scanCompleted.current) return

    scanCompleted.current = true

    const obj = {
      ticketPassBarcode: ticketData?.ticketPasses[0]?.barcode,
      qrCode: data?.text,
    }

    setTimeout(() => {
      dispatch(selfScanWallet(obj))
        .then(data => {
          setScannedOn(data.data?.scanHistory)
          setStatus('success', data?.data?.scannedOn)
        })
        .catch(error => {
          setStatus('fail', error?.response?.data?.error)
        })
        .finally(() => {
          scanCompleted.current = false
        })
    }, 2000)
  }

  const handleError = err => {
    scanCompleted.current = false
    setStatus('fail', err?.response?.data?.error)
  }

  const toggleFlash = () => {
    setFlashEnabled(prev => !prev)
  }
  const allScans = ticketData?.ticketPasses.flatMap(pass => pass.scans) || scannedOn
  const setStatus = (status, message) => {
    setScanningStatus({ status, message })
    setTimeout(() => {
      setShowScanner(false)
    }, 2000)
  }
  const handleScanQRCode = () => {
    if (cameraAccess) {
      setShowScanner(true)
    } else {
      notification.error({ message: 'Camera access denied' })
    }
  }
  const dateScanned = moment(scannedOn[0]?.scannedOn).format('MMM D, YYYY')
  const timeScanned = moment(scannedOn[0]?.scannedOn).format('h:mm A')
  const avatar = user?.image ? <img className='avatarWallet' src={user?.image?.original} alt='' /> : <Avatar size={224} icon={<UserOutlined />} className='defaultAvatarWallet' />
  // parent approval is on , this is a kid and parent has not approved
  const showParentPending = parentApproveStatus === 'PENDING' && ticketData?.isMinor && ticketData?.parentApproval
  const showManagerPending = !ticketData?.managerApproved && !showParentPending
  return (
    <>
      {showScanner && (
        <div className='qrScannerWrapper'>
          <QRScanner
            onError={handleError}
            onScan={handleScan}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            constraints={{
              video: {
                facingMode: 'environment',
                torch: flashEnabled,
              },
            }}
          />
          <div className='qrScannerBtnWrapper'>
            <CustomButton
              text='Cancel'
              className='stopScanning'
              type='dark'
              onClick={() => setShowScanner(false)}
            />
            {isTablet &&
              <CustomButton
                className={`flashToggle ${flashEnabled ? 'flash-on' : 'flash-off'}`}
                text={<FlashIcon className='flash-icon' />}
                type='dark'
                onClick={toggleFlash}
              />}
          </div>
        </div>
      )}
      {scanningStatus !== null && cameraAccess && (
        <div className={c('endScanningWrapper', { successScanning: scanningStatus?.status === 'success' })}>
          <div className='response-status-member'>
            <div className='response-container-member'>
              {scanningStatus?.status === 'success' ? (
                <img className='avatarSuccessScanning' src={user?.image?.original} alt='' />
              ) : (
                <img src={icons[scanningStatus?.status]} alt='icon' className='status-icon' />
              )}
              {scanningStatus?.status === 'success' ? (
                <div className={c('statusResultTitle', { successScanning: scanningStatus?.status === 'success' })}>Success</div>
              ) : (
                <div className='statusResultTitle'>Pass Inactive</div>
              )}
              {scanningStatus?.status === 'success' && <div className='successName'>{user?.firstName + ' ' + user?.lastName}</div>}
              {scanningStatus?.status === 'success' && (
                <div className={c('eventName', { successScanning: scanningStatus?.status === 'success' })}>{ticketData?.eventName}</div>
              )}
              <div className={c('dateScanned', { successScanning: scanningStatus?.status === 'success' })}>{dateScanned}</div>
              <div className={c('timeScanned', { successScanning: scanningStatus?.status === 'success' })}>{timeScanned}</div>
              {scanningStatus?.message && (<span className='response-message'>{scanningStatus?.message}</span>)}
            </div>
            <CustomButton
              text='Ok'
              className={c('okBtn', { successScanning: scanningStatus?.status === 'success' })}
              type='dark'
              onClick={() => setScanningStatus(null)}
            />
          </div>
        </div>
      )}
      <MemberLyfeLayout className='detailMembershipLayoutWrapper'>

        {showParentPending && (
          <div className='inactiveBlock'>
            <div className='inactiveWrapper'>
              <div className='titleInactive'>Inactive Account</div>
              <div className='messageWrapper'>
                <div className='inactiveMessage'>We have sent an email with instructions to your parents at</div>
                <div className='emailMessage'>{parentEmail}</div>
                <div className='inactiveMessage'>Please check your inbox</div>
              </div>
              <div className='btnInactiveWrapper'>
                <CustomButton
                  text='Change Email'
                  className='changeEmail'
                  onClick={() => setVisible(true)}
                  type='dark'
                />
                <CustomButton
                  text='Resend Email'
                  className='resendEmail'
                  onClick={resendEmailHandler}
                  type='dark'
                />
              </div>
            </div>
          </div>
        )}
        {showManagerPending && (
          <div className='inactiveBlock'>
            <div className='inactiveWrapper'>
              <div className='titleInactive'>Inactive Account</div>
              <div className='messageWrapper'>
                <div className='inactiveMessage'>Pending approval from the manager.</div>
                {signupFields.length > 0 || ticketData?.rosterDoB &&
                  <div className='inactiveMessage'>Complete your profile information to speed up the approval process</div>}
              </div>
              {signupFields.length > 0 || ticketData?.rosterDoB
                ? (
                  <div className='btnInactiveWrapper'>
                    <CustomButton
                      text='Update Your Profile'
                      className='resendEmail'
                      onClick={() => setVisibleAdditionalInformation(true)}
                      type='dark'
                    />
                  </div>
                ) : null}
            </div>
          </div>
        )}
        <div className='detailVisitWrapper'>
          <div className='detailMembershipWrapper'>
            <div className='headerDetailWrapper'>
              {avatar}
              <div className='namesWrapper'>
                <div className='eventName'>{ticketData?.eventName}</div>
                <div className='ticketName'>{ticketData?.ticketName}</div>
              </div>
            </div>
            <div className='bottomDetailWrapper'>
              <div className='detailsWrapper'>
                <div className='details'>
                  <div className='name'>{user?.firstName + ' ' + user?.lastName}</div>
                  <div className='userName'>{user?.userName}</div>
                </div>
                <div className='btnMemberWrpapper'>
                  <CustomButton
                    text='Visit Home Page'
                    className='visitHomePage'
                    type='dark'
                    onClick={handleVisitHomePage}
                  />
                  {!ticketData?.managerApproved ? null
                    : (
                      <CustomButton
                        text='Scan QR Code'
                        className='scanQRCode'
                        type='dark'
                        onClick={handleScanQRCode}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
          <VisitHistory scans={allScans} />
        </div>
        <ModalChangeEmail submitForm={changeEmailHandler} visible={visible} setVisible={setVisible} />
        {visibleAdditionalInformation &&
          <ModalAdditionalInformation
            visible={visibleAdditionalInformation}
            eventID={ticketData.eventID}
            page='wallet'
            rosterDoB={ticketData?.rosterDoB}
            parentApproval={ticketData?.parentApproval}
            signupFields={signupFields}
            setVisible={setVisibleAdditionalInformation}
          />}
      </MemberLyfeLayout>
    </>
  )
}
export default DetailMembership
